var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3315_2127",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H0V18H18V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3315_2127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.93002 13.852H14.361C14.6432 13.8521 14.9227 13.7966 15.1833 13.6885C15.444 13.5805 15.6808 13.4221 15.8802 13.2223C16.0795 13.0226 16.2375 12.7855 16.3451 12.5246C16.4526 12.2637 16.5077 11.9842 16.507 11.702L16.493 4.142C16.4922 3.57363 16.2659 3.02881 15.8637 2.62719C15.4615 2.22558 14.9164 2 14.348 2H3.63902C3.35708 2 3.07791 2.05558 2.81747 2.16356C2.55703 2.27155 2.32044 2.42982 2.12122 2.62932C1.92199 2.82882 1.76406 3.06563 1.65644 3.32622C1.54882 3.58681 1.49363 3.86606 1.49402 4.148V11.707C1.49402 12.2759 1.72001 12.8215 2.12228 13.2237C2.52454 13.626 3.07013 13.852 3.63902 13.852V16L7.93002 13.852Z",
    stroke: "#9EA5B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 8.74901C9.41421 8.74901 9.75 8.41322 9.75 7.99901C9.75 7.58479 9.41421 7.24901 9 7.24901C8.58579 7.24901 8.25 7.58479 8.25 7.99901C8.25 8.41322 8.58579 8.74901 9 8.74901Z",
    fill: "#9EA5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.74901C12.4142 8.74901 12.75 8.41322 12.75 7.99901C12.75 7.58479 12.4142 7.24901 12 7.24901C11.5858 7.24901 11.25 7.58479 11.25 7.99901C11.25 8.41322 11.5858 8.74901 12 8.74901Z",
    fill: "#9EA5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8.74901C6.41421 8.74901 6.75 8.41322 6.75 7.99901C6.75 7.58479 6.41421 7.24901 6 7.24901C5.58579 7.24901 5.25 7.58479 5.25 7.99901C5.25 8.41322 5.58579 8.74901 6 8.74901Z",
    fill: "#9EA5B1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message_icon.d4b83b806a6a3d20bfa847804daf81f8.svg";
export { ForwardRef as ReactComponent };